(() => {
  if (window.PhazeMateriaEvents) return;
  class CartAddEvent extends CustomEvent {
    constructor(cart, source, data) {
      super('phaze:materia-cart-add', { detail: { cart, source, ...data } });
    }
  }
  class CartUpdateEvent extends CustomEvent {
    constructor(cart, source, data) {
      super('phaze:materia-cart-refresh', { detail: { cart, source, ...data } });
    }
  }
  window.PhazeMateriaEvents = { CartAddEvent, CartUpdateEvent };

  async function refreshCart(currentCart, open) {
    const root = window.Shopify?.routes?.root || '/';
    const cart = currentCart || await fetch(root + 'cart.js', {
      credentials: 'same-origin', headers: { Accept: 'application/json' }
    }).then(response => response.ok ? response.json() : null);
    if (cart) {
      document.querySelectorAll('.cart-count').forEach(element => {
        element.textContent = element.classList.contains('cart-count-drawer') ? `(${cart.item_count})` : String(cart.item_count);
      });
      document.querySelector('header-total-price')?.updateTotal?.(cart);
      document.querySelector('free-ship-progress-bar')?.init?.(cart.items_subtotal_price);
    }
    const drawer = document.querySelector('cart-notification, cart-drawer');
    if (!drawer) return;
    const sections = drawer.getSectionsToRender?.().map(section => section.id).slice(0, 5) || ['minicart-form'];
    const response = await fetch(root + '?sections=' + sections.map(encodeURIComponent).join(','), {
      credentials: 'same-origin', headers: { Accept: 'application/json' }
    });
    if (response.ok) {
      const htmlSections = await response.json();
      sections.forEach(id => {
        if (!htmlSections[id]) return;
        const parsed = new DOMParser().parseFromString(htmlSections[id], 'text/html');
        const target = document.getElementById(id);
        const content = parsed.getElementById(id);
        if (target && content) target.innerHTML = content.innerHTML;
      });
      drawer.cartAction?.();
    }
    if (open) drawer.open?.();
  }
  document.addEventListener('phaze:materia-cart-add', event => {
    refreshCart(event.detail?.cart, true).catch(error => console.error('Phaze cart refresh:', error));
  });
  document.addEventListener('phaze:materia-cart-refresh', event => {
    refreshCart(event.detail?.cart, false).catch(error => console.error('Phaze cart refresh:', error));
  });

  if (!customElements.get('phaze-product-description')) {
    customElements.define('phaze-product-description', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const toggle = this.querySelector('[data-description-toggle]');
        const preview = this.querySelector('[data-description-preview]');
        const full = this.querySelector('[data-description-full]');
        if (!toggle || !preview || !full) return;
        toggle.addEventListener('click', () => {
          const expanded = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = expanded ? toggle.dataset.less : toggle.dataset.more;
          preview.hidden = expanded;
          full.hidden = !expanded;
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  if (!customElements.get('phaze-materia-recommendations')) {
    customElements.define('phaze-materia-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true' || !this.dataset.url) return;
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        }, { rootMargin: '300px' });
        this.observer.observe(this);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
      async load() {
        try {
          const response = await fetch(this.dataset.url, { credentials: 'same-origin' });
          if (!response.ok) return;
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const replacement = parsed.getElementById(this.id);
          if (replacement?.querySelector('.phaze-materia-recommendations__card')) {
            this.innerHTML = replacement.innerHTML;
          }
          this.dataset.loaded = 'true';
        } catch (error) {
          console.error('Phaze product recommendations:', error);
        }
      }
    });
  }

  document.addEventListener('submit', async event => {
    const form = event.target.closest('.phaze-materia-recommendation-form');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.loading === 'true') return;
    const id = event.submitter?.value || new FormData(form).get('id');
    if (!id) return;
    const card = form.closest('.phaze-materia-recommendations__card');
    const status = card.querySelector('[data-add-status]');
    const button = event.submitter;
    form.dataset.loading = 'true';
    form.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    status.textContent = card.dataset.adding;
    let added = false;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] })
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || card.dataset.error);
      added = true;
      status.textContent = card.dataset.added;
      card.querySelector('details')?.removeAttribute('open');
      await refreshCart(null, true);
    } catch (error) {
      status.textContent = added ? card.dataset.added : error.message || card.dataset.error;
    } finally {
      form.dataset.loading = 'false';
      form.setAttribute('aria-busy', 'false');
      if (button) button.disabled = false;
    }
  });
})();
